import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import VueRouter from "vue-router";
import { postGateway } from "./request/index";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import moment from "moment";
import Viewer from "v-viewer";
import JSEncrypt from "@/utils/jsencrypt.js";
import "viewerjs/dist/viewer.css";
import "@/assets/iconfont/iconfont.css";
import { isUkIp } from "@/utils/judgeUseGoogle.js";
import { recordAppStartup } from "@/utils/domainStats.js";
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

// 设置语言
locale.use(lang)


Vue.use(Viewer);
Viewer.setDefaults({
    Options: {
        inline: true,
        button: true,
        navbar: true,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: "data-source",
    },
});
// 登录配置内容  密码加密
Vue.prototype.$encryptByPublicKey = function(content) {
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAMEfmsO1l44W6/RS9Hkx74Ey36aHExrCvjFYhRVP7/Q+8SG+vWFxMvGShQTA8EfQS2ECgDhVc+LFB14qhFl/JEcCAwEAAQ=="
    );
    return encrypt.encrypt(content);
};

import {
    Button,
    Select,
    Backtop,
    Breadcrumb,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    BreadcrumbItem,
    Dialog,
    Radio,
    RadioGroup,
    Rate,
    Skeleton,
    SkeletonItem,
    Switch,
    Popover,
    Message,
    Carousel,
    CarouselItem,
    CascaderPanel,
    Cascader,
    Loading,
    Alert,
    MessageBox,
    Input,
    Form,
    Col,
    Row,
    FormItem,
    Divider,
    Option,
    Steps,
    Step,
    Upload,
    RadioButton,
    InputNumber,
    Drawer,
    Popconfirm,
    Tooltip,
} from "element-ui"; // 按需引入 element

Vue.use(Button);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Backtop);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Dialog);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Rate);
Vue.use(Skeleton);
Vue.use(SkeletonItem);
Vue.use(Popover);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(CascaderPanel);
Vue.use(Cascader);
Vue.use(Input);
Vue.use(Loading);
Vue.use(Alert);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Upload);
Vue.use(Popconfirm);
Vue.use(Tooltip);

Vue.use(Form);
Vue.use(Col);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Row);
Vue.use(Divider);
Vue.use(Option);
Vue.use(Drawer);


// 处理message
//定义一个新的Message方法，多传入一个offset参数
const $message = options => {
    return Message({
        offset: 200,
        ...options
    });
};

//重写方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(type => {
    $message[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options,
                offset: 200
            };
        }
        if (typeof options === 'object') {
            options.type = type;
        }
        return Message(options);
    };
})

Vue.use(VueAwesomeSwiper);
Vue.use(VueRouter);
Vue.config.productionTip = false;
Vue.prototype.$postGateway = postGateway;
Vue.prototype.$moment = moment;
Vue.prototype.$message = $message;
Vue.prototype.$message.closeAll = Message.closeAll;

Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$imgBaseUrl = 'http://www.alleatapp.com/food/img/'; // 上传图片前缀地址
Vue.prototype.$isUk = getDevelopSetting();
// 初始化 cloudflareVerify 配置，默认为 true（使用Cloudflare验证）
Vue.prototype.$cloudflareVerify = true;

function getDevelopSetting() {
    if(localStorage.getItem('ipLocat') == 'UK') {
        Vue.prototype.$isUk = true;
    }
    if(localStorage.getItem('ipLocat') == 'Ireland') {
        Vue.prototype.$isUk = false;
    }
    return localStorage.getItem('ipLocat') == 'UK'
}


if(!localStorage.getItem('ipLocat')) {
    isUkIp().then(() => {
        Vue.prototype.$isUk = true;
        localStorage.setItem('ipLocat', 'UK')
        getDevelopSetting();
        
    }).catch(() => {
        Vue.prototype.$isUk = false;
        localStorage.setItem('ipLocat', 'Ireland')
        getDevelopSetting();
    })
} else {
    getDevelopSetting()
}

// 加载应用配置文件
function loadAppConfig() {
    fetch('https://assets.alleatapp.com/appConfigFile/appConfig.json')
        .then(res => {
            if (!res.ok) {
                throw new Error('Failed to fetch app config');
            }
            return res.json();
        })
        .then(config => {
            // 读取 cloudflareVerify 配置
            Vue.prototype.$cloudflareVerify = Boolean(config.cloudflareVerify);
            console.log('Cloudflare Verify Config:', Vue.prototype.$cloudflareVerify);
        })
        .catch(err => {
            console.error('加载应用配置失败:', err);
            // 默认使用Cloudflare验证
            Vue.prototype.$cloudflareVerify = true;
        });
}

// 在应用启动前加载配置
loadAppConfig();

new Vue({
    el: "#app",
    render: (h) => h(App),
    router,
    mounted: () => {
        // 记录应用启动时的域名访问
        recordAppStartup();
        
        setTimeout(() => {
            document.dispatchEvent(new Event("render-event"));
        }, 5000);
    },
});